function selectorcaixetesesborrar() {
  if ($(this).closest('ol').find('li.selector').length > 1) {
    $(this).closest('li').remove();
  }

  return false;
}

function destinatarisesborrar() {
  if ($(this).closest('ol').find('li.opcio').length > 1) {
    $(this).closest('li').remove();
  }

  return false;
}

function inputOpcionsesborrar() {
  if ($(this).closest('ol').find('li.opcio').length > 1) {
    $(this).closest('li').remove();
  }

  return false;
}

function searchFilter(data) {
  return data
    .replace(/ñ/g, 'η')
    .replace(/\n/g, ' ')
    .replace(/[áàäâ]/g, 'a')
    .replace(/[ÁÀÄÂ]/g, 'A')
    .replace(/[éèëê]/g, 'e')
    .replace(/[ÉÈËÊ]/g, 'E')
    .replace(/[íìïî]/g, 'i')
    .replace(/[ÍÌÏÎ]/g, 'I')
    .replace(/[óòöô]/g, 'o')
    .replace(/[ÓÒÖÔ]/g, 'O')
    .replace(/[úùüû]/g, 'u')
    .replace(/[ÚÙÜÛ]/g, 'U')
    .replace(/ç/g, 'c')
    .toLowerCase();
}

$(document).ready(function() {
  vex.defaultOptions.className = 'vex-theme-default';

  // Tooltip bootstrap-tooltip.js
  $('*[rel=tooltip]').tooltip({
    animation: false
  });
  $('input[title]').tooltip({
    animation: false,
    placement: 'right'
  });
  $('.tooltip-large').tooltip({
    animation: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>'
  });

  // Enllaços externs en finestra nova
  $('a[rel=external]').attr('target', '_blank').addClass('external');

  if ($('.flashMessenger').length > 0) {
    window.setTimeout(function() {
      $('.flashMessenger').fadeTo(500, 0).slideUp(500, function() {
        $(this).remove();
      });
    }, 4000);
  }

  //Mostrar el calendari al seleccionar l'element
  /*$('input[type="date"],input[type="datetime-local"]').on('focus', function(){
    $(this).get(0).showPicker();
  });*/


  $('.multidates').each(function(){
    //Controla els rangs de data
    $(this).on('change', '.dataRange input:nth-child(1)', function(){
      var input1 = $(this).closest('.dataRange').find('input:nth-child(1)');
      var input2 = $(this).closest('.dataRange').find('input:nth-child(2)');
      if (input2.val() < input1.val()) {
        input2.val(input1.val());
      }
      input2.attr('min', input1.val());
    });
    $(this).on('change', '.dataRange input:nth-child(2)', function(){
      var input1 = $(this).closest('.dataRange').find('input:nth-child(1)');
      var input2 = $(this).closest('.dataRange').find('input:nth-child(2)');
      if (input1.val() > input2.val()) {
        input1.val(input2.val());
      }
      input1.attr('max', input2.val());
    });

  });


  if ($('.colorpicker').length > 0) {
    // Inicialitzar datapickers
    if ($('.colorpicker').length > 0) {
      $('.colorpicker').colorpicker();
    }
  }

  // Inicialitza validator
  if (jQuery.validator) {
    jQuery.validator.setDefaults({
      errorElement: 'span',
      errorPlacement: function(error, element) {
        var editor = element.parent().find('div.cke');
        if (editor.length > 0) {
          error.css('display', 'inline-block').css('margin-top', '3px').insertAfter(editor);
        } else if (element.is('textarea') && element.is('editorLine, editorAll, editorMedium, editorBasic')) {
            element.parent().append(error);
        } else if (element.is('[type=radio]') || element.is('[type=checkbox]')) {
          error.insertAfter(element.closest('label'));
        } else if (element.parent('.input-group').length) {
          error.insertAfter(element.parent());
        } else {
          error.insertAfter(element);
        }
      },
      highlight: function(element) {
        $(element).closest('.form-group').addClass('has-error');
      },
      unhighlight: function(element) {
        $(element).closest('.form-group').removeClass('has-error');
      }
    });
    // Missatge a la mateixa línea
    $('.validate').each(function() {
      $(this).validate();
    });
    // Sense missatge
    $('.validateNoMessage').each(function() {
      $(this).validate({
        errorPlacement: function(error, element) {
          if (element.is('[type=radio]') || element.is('[type=checkbox]')) {
            error.insertAfter(element.closest('label'));
          } else if (element.parent('.input-group').length) {
            error.insertAfter(element.parent());
          } else {
            error.insertAfter(element);
          }
        }
      });
    });
    // Missatge sota el input
    $('.validateBlock').each(function() {
      $(this).validate({
        errorElement: 'div',
        errorPlacement: function(error, element) {
          if (element.is('[type=radio]') || element.is('[type=checkbox]')) {
            error.insertAfter(element.closest('label'));
          } else if (element.parent('.input-group').length) {
            error.insertAfter(element.parent());
          } else {
            error.insertAfter(element);
          }
        }
      });
    });

    $('input.folderNameCheck').each(function() {
      var input = $(this);
      input.rules('add', {
        remote: {
          url: '../carpetes/checkNameAjax.php',
          type: 'post',
          data: {
            current: input.attr('value'),
            parent: input.data('parent'),
            lg: input.attr('lang')
          }
        },
        messages: {
          remote: 'Nom no disponible'
        }
      });
    });
  }

  // Selector domini de la capçalera
  $('#changeDomain input').hide();
  $('#changeDomain select').on('change', function() {
    $(this).parent().submit();
  });

  // Portada
  if ($('#anarcarpetes').length > 0) {
    $('#anarcarpetes').change(function() {
      window.location = $(this).val();
    });
  }
  // Fi portada

  // Usuaris
  if ($('input[data-random]').length > 0) {
    $('input[data-random]').each(function() {
      var randomInput = $(this);
      randomInput.after('<p><a href="#" class="randomPass" style="margin-top: 4px;"><i class="fa fa-sync" aria-hidden="true"></i> ' + randomInput.attr('data-random') + '</a></p>');
      $('.randomPass').on('click', function(event) {
        event.preventDefault();
        var password = $.passGen({length: 12, numeric: true, lowercase: true, uppercase: true, special: false});
        randomInput.val(password).attr('type', 'text');
        $('#' + randomInput.attr('id') + '_bis').val(password);
        randomInput.closest('div').find('a.reveal i').removeClass('fa-eye-slash').addClass('fa-eye');
      });
    });
  }

  // Usuaris
  if ($('input[data-password-reveal]').length > 0) {
    $('input[data-password-reveal]').each(function() {
      var passwordInput = $(this);
      passwordInput.wrap('<div class="input-group">');
      passwordInput.after('<div class="input-group-addon"><a href="#" class="reveal"><i class="fa fa-eye-slash" aria-hidden="true"></i></a></div>');
      passwordInput.closest('div').find('a.reveal').on('click', function(event) {
        event.preventDefault();
        if (passwordInput.attr('type') === 'text') {
          passwordInput.attr('type', 'password');
          $(this).find('i').addClass('fa-eye-slash');
          $(this).find('i').removeClass('fa-eye');
        } else if (passwordInput.attr('type') === 'password') {
          passwordInput.attr('type', 'text');
          $(this).find('i').removeClass('fa-eye-slash');
          $(this).find('i').addClass('fa-eye');
        }
      });
    });
  }

  if ($('#expireData').length > 0 && $('#enable_expiration').length > 0) {
    if (!$('#enable_expiration').is(':checked')) {
      $('#expireData').hide();
    }

    $('#enable_expiration').on('change', function() {
      $('#expireData').toggle($('#enable_expiration').is(':checked'));
    });
  }
  // Fi usuaris

  // Carpetes
  if ($('#active_domini').length > 0 && $('#active_domini_url').length > 0) {
    if ($('#active_domini').not(':checked')) {
      $('#active_domini_url').hide();
    }

    $('#active_domini').on('change', function() {
      $('#active_domini_url').toggle();
    });
  }
  // Fi carpetes

  // camps si check marcat
  if ($('input[data-extra]').length > 0) {
    $('input[data-extra]').each(function() {
      var extra = $(this).data('extra');
      if ($(this).prop('checked') == false) {
        $('#' + extra).hide();
      }

      $(this).on('change', function() {
        var extra = $(this).data('extra');
        $('#' + extra).toggle();
      });
    });
  }
  // Fi camps si check marcat

  // cerca
  $('.search #ordenar').on('change', function() {
    $(this).closest('form').submit();
  });

  $('.popupIframe').each(function() {
    $(this).magnificPopup({
      type: 'iframe'
    });
  });

  $('.popupImage').each(function() {
    $(this).magnificPopup({
      type: 'image',
      image: {
        titleSrc: 'title',
        verticalFit: true
      }
    });
  });

  $('.template-gallery').each(function() {
    var gallery = $(this);

    gallery.find('div.element').addClass('found');

    var pageSize = 12;
    var currentPage = 1;
    var totalPages = 0;

    var showPage = function() {
      gallery.find('.element.found').hide().each(function(n) {
        if (n >= pageSize * (currentPage - 1) && n < pageSize * currentPage) {
          $(this).show();
        }
      });
    };

    var resetPaginate = function() {
      var pagesCount = gallery.find('.element.found').length;
      currentPage = 1;

      var nav = '';
      totalPages = Math.ceil(pagesCount / pageSize);
      gallery.find('.numeros').remove();
      for (var s = 0; s < totalPages; s++) {
        nav += '<li class="numeros"><a href="#">' + (s + 1) + '</a></li>';
      }

      gallery.find('.pag_prev').after(nav);
      gallery.find('.numeros').first().addClass('active');
      showPage();
    };

    resetPaginate();

    gallery.find('.pagination').on('click', 'li.numeros', function() {
      $('.pagination li').removeClass('active');
      $(this).addClass('active');
      currentPage = parseInt($(this).text());
      showPage();
    });

    gallery.find('.pagination li.pag_prev').click(function() {
      if ($(this).next().is('.active')) {
        return;
      }

      $('.numeros.active').removeClass('active').prev().addClass('active');
      currentPage = currentPage > 1 ? (currentPage - 1) : 1;
      showPage();
    });

    gallery.find('.pagination li.pag_next').click(function() {
      if ($(this).prev().is('.active')) {
        return;
      }

      $('.numeros.active').removeClass('active').next().addClass('active');
      currentPage = currentPage < totalPages ? (currentPage + 1) : totalPages;
      showPage();
    });

    gallery.find('input.search').on('keyup', function(event) {
      event.preventDefault();
      var value = searchFilter($(this).val());
      gallery.find('div.element').filter(function() {
        $(this).toggle(searchFilter($(this).data('search')).indexOf(value) > -1);
        $(this).toggleClass('found', searchFilter($(this).data('search')).indexOf(value) > -1);
        resetPaginate();
      });
    });

    gallery.magnificPopup({
      delegate: 'a.template-img',
      type: 'image',
      gallery: {
        enabled: true,
        navigateByImgClick: true
      },
      image: {
        titleSrc: 'title',
        verticalFit: true
      }
    });
  });

  $('.selectorcaixetes').each(function() {
    var selectorcaixetes = $(this);
    if (selectorcaixetes.data('disabled')) {
      selectorcaixetes.find('.move, .add, .delete').hide();
      return;
    }

    var selectorcaixetesUltim = selectorcaixetes.find('li.selector:last').html();

    selectorcaixetes.find('ol').sortable({
      handle: '.move',
      placeholder: 'sortable-placeholder',
      start: function(e, ui) {
        ui.placeholder.height(ui.item.height());
      }
    });
    selectorcaixetes.find('a.delete').on('click', selectorcaixetesesborrar);

    selectorcaixetes.find('a.add').on('click', function() {
      var ol = $(this).closest('.selectorcaixetes').find('ol');
      var name = ol.find('select').attr('name');
      ol.append('<li class="selector">' + selectorcaixetesUltim + '</li>');
      ol.find('li.selector:last select').attr('name', name);
      ol.find('li.selector:last select').select2({
        width: '75%',
        allowClear: true
      });
      ol.find('li.selector:last a.delete').on('click', selectorcaixetesesborrar);
      return false;
    });

    selectorcaixetes.find('li.selector select').select2({
      width: '75%',
      allowClear: true
    });
  });

  var destinataris = $('.destinataris');
  if (destinataris.length > 0) {
    var destinatarisUltim = destinataris.find('li.opcio:last').html();

    destinataris.find('a.delete').on('click', destinatarisesborrar);

    destinataris.find('a.add').on('click', function() {
      var ol = $(this).parent().find('ol');
      ol.append('<li class="opcio">' + destinatarisUltim + '</li>');
      ol.find('li.opcio:last a.delete').on('click', destinatarisesborrar);
      return false;
    });
  }

  var inputOpcions = $('#inputOpcions');
  if (inputOpcions.length > 0) {
    var inputOpcionsUltim = inputOpcions.find('li.opcio:last').html();

    inputOpcions.find('ol').sortable({
      handle: '.move',
      placeholder: 'sortable-placeholder',
      start: function(e, ui) {
        ui.placeholder.height(ui.item.height());
      }
    });

    inputOpcions.find('a.delete').on('click', inputOpcionsesborrar);

    inputOpcions.find('a.add').on('click', function() {
      var ol = $(this).parent().find('ol');
      ol.append('<li class="opcio">' + inputOpcionsUltim + '</li>');
      ol.find('li.opcio:last a.delete').on('click', inputOpcionsesborrar);
      ol.find('*[rel=tooltip]').tooltip({
        animation: false
      });
      return false;
    });
  }

  $('textarea.autosize').each(function() {
    autosize($(this));
  });

  $('[data-toggle="popover"]').popover();

  if ($('.check-all').length > 0) {
    $('.check-all').each(function() {
      var options = {
        container: $(this).closest('.check-all-group'),
        childCheckboxes: 'input[type=checkbox]:enabled',
        showIndeterminate: true
      };
      $(this).checkAll(options);
    });
  }

  if ($('.folder-perms').length > 0) {
    function folderDepthUpdate(checkbox) {
      var elem = checkbox.closest('li');
      if (checkbox.is(':checked')) {
        elem.find('ul input[type="checkbox"]')
        .prop('checked', false)
        .trigger("change")
        .prop('disabled', true)
        .hide();
      } else {
        elem.find('ul input[type="checkbox"]')
        .prop('disabled', false)
        .show();

      }
    }
    $('.folder-perms').each(function() {
      $(this).find('li>label input[type="checkbox"]').each(function() {
        var checkbox = $(this);
        if (typeof checkbox.data('folder') === 'undefined') {
          return;
        }
        if (!checkbox.is(':checked')) {
          $('#depth_'+checkbox.data('folder')).hide();
        }
        checkbox.on('change', function(){
          if ($(this).is(':checked')) {
            $('#depth_'+$(this).data('folder')).show();
          } else {
            $('#depth_'+$(this).data('folder')).hide();
          }
          $('#depth_'+$(this).data('folder'))
            .find('input[type="checkbox"]')
            .prop('checked', false)
            .trigger("change")
            ;
        });
        var depth = $('#depth_'+checkbox.data('folder')).find('input[type="checkbox"]');
        if (depth.is(':checked')) {
          folderDepthUpdate(depth);
        }
        depth.on('change', function() {
          console.log('change');
          folderDepthUpdate(depth);
        });
      });
    });
  }

  $('input[autofocus]').trigger('focus');

  jQuery.validator.addMethod('unique', function(value, element, param) {
    'use strict';
    var result = false;
    var old = $(element).attr('value');

    $.ajax({
      type: 'POST',
      async: false,
      url: param, // Script to validate in server side
      data: {value: value, first: old},
      success: function(data) {
        result = (data == true);
      }
    });
    return this.optional(element) || result;
  }, 'Please enter another value, this field does not allow duplicates.');

  jQuery.validator.addMethod('passwordCheck', function(value, element, param) {
    'use strict';
    var result = false;
    $.ajax({
      type: 'POST',
      async: false,
      url: param, // Script to validate in server side
      data: {value: value},
      success: function(data) {
        result = (data == true);
      }
    });
    return this.optional(element) || result;
  }, 'It is mandatory to use strong passwords.');

  var lang = $('html').attr('lang');
  if (lang === 'ca') {
    jQuery.extend(jQuery.validator.messages, {
      unique: 'Si us plau, introdueixi un altre valor, aquest camp no permet duplicats.',
      passwordCheck: 'És obligatori l\'ús de claus fortes'
    });
  } else if (lang === 'es') {
    jQuery.extend(jQuery.validator.messages, {
      unique: 'Por favor, introduzca otro valor, este campo no permite duplicados.',
      passwordCheck: 'Es obligatorio el uso de claves fuertes'
    });
  }

  if ($('#REBRE_EMAILS').length) {
    if ($('#REBRE_EMAILS').is(':not(:checked)')) {
      $('.destinataris').hide();
    }

    $('#REBRE_EMAILS').on('change', function() {
      $('.destinataris').toggle();
    });

    $('.opcio input').rules('add', {
      required: function() {
        return $('#REBRE_EMAILS:checked').length > 0;
      }
    });
  }

  if ($('.groupVisibility').length) {
    if ($('#VISIBLE_FOR_ALL_GROUPS').is(':checked')) {
      $('.groupSelector').show();
    } else {
      $('.groupSelector').hide();
    }

    $('body').on('change', '#VISIBLE_FOR_ALL_GROUPS', function() {
      if ($(this).is(':checked')) {
        $('.groupSelector').show();
      } else {
        $('.groupSelector').hide();
      }
    });
  }

  if ($('select.template-type').length > 0) {
    $('select.template-type').each(function() {
      var value = $(this).val();
      var extra = $(this).closest('.row').find('.extra');
      extra.each(function() {
        var elem = $(this);
        if (elem.hasClass(value)) {
          elem.show();
          elem.find('input, select').attr('disabled', false);
        } else {
          elem.hide();
          elem.find('input, select').attr('disabled', true);
        }
      });
    }).on('change', function() {
      var value = $(this).val();
      var extra = $(this).closest('.row').find('.extra');
      extra.each(function() {
        var elem = $(this);
        if (elem.hasClass(value)) {
          elem.show();
          elem.find('input, select').attr('disabled', false);
        } else {
          elem.hide();
          elem.find('input, select').attr('disabled', true);
        }
      });
    });
  }

  if ($('.form-selector').length > 0) {
    function formControl(elem) {
      var select = elem.find('select');
      elem.find('.form-texts').toggle(select.val() !== '');
      elem.find('.formExport').toggle(select.val() !== '');
      elem.find('.formEdit').toggle(select.val() !== '');
      elem.find('.formView').toggle(select.val() !== '');
      elem.find('.formAdd').toggle(select.val() === '');
      if (select.val() !== '') {
        elem.find('.formExport').attr('href', '../formularis/export/index.php?ID=' + select.val());
        elem.find('.formEdit').attr('href', '../formularis/edita.php?ID=' + select.val());
        elem.find('.formView').attr('href', '../formularis/veure.php?id=' + select.val());
      } else {
        elem.find('.formExport').attr('href', '#');
        elem.find('.formEdit').attr('href', '#');
        elem.find('.formView').attr('href', '#');
      }
    }

    $('.form-selector').each(function() {
      formControl($(this));
      $(this).find('select').on('change', function() {
        formControl($(this).closest('.form-selector'));
      });
    });
  }

  $('.enableChecker').each(function() {
    var checker = $(this);
    var checkerId = checker.attr('id');
    var enableChecker = function() {
      var content = $('#' + checkerId + '-content');
      content.toggle(checker.is(':checked'));
      content.find('input,select').prop('disabled', checker.is(':checked') == false);
    };
    checker.on('change', enableChecker);
    enableChecker();
  });

  $('.fileThumbnail .deleteFile input').on('change', function() {
    $(this).closest('div').find('a').remove();
    $(this).closest('div').hide();
  });

  $('.multipleOptions').each(function() {
    var multi = $(this);
    var newField = multi.find('ul').data('new');

    multi.find('ul').sortable({
      handle: '.move',
      placeholder: 'sortable-placeholder',
      start: function(e, ui){
        ui.placeholder.height(ui.item.height());
      }
    });

    multi.find('ul').on('click', 'li a.delete', function(event) {
      event.preventDefault();
      if (multi.find('ul li').length <= 1) {
        return;
      }

      $(this).closest('li').remove();
    });

    multi.find('a.add').on('click', function(event) {
      event.preventDefault();
      var ul = $(this).closest('div').find('ul');

      ul.append(newField);

      ul.find('*[rel=tooltip]').tooltip({
        animation: false
      });

      return false;
    });
  });

  var langnav = $('div.idiomes[data-sticky], div.page-header[data-sticky]');
  if (langnav.length > 0) {
    var sticky = langnav.offset();
    var stickyWith = langnav.width();
    var stickyHeight = langnav.outerHeight(true);
    var stickyPadding = $('<div></div>').insertAfter(langnav);
    langnav.width(stickyWith);
    window.onscroll = function() {
      if (window.pageYOffset >= sticky.top) {
        langnav.addClass('sticky');
        stickyPadding.css('height', stickyHeight);
      } else {
        langnav.removeClass('sticky');
        stickyPadding.css('height', 0);
      }
    };
  }

  $('ol.templateSortablefields').each(function() {
    $(this).sortable({
      handle: '.move',
      placeholder: 'sortable-placeholder',
      start: function(e, ui) {
        ui.placeholder.height(ui.item.height());
      }
    });
  });

  $('.editoraForm fieldset input, .editoraForm fieldset select, .editoraForm fieldset textarea, .editoraForm fieldset checkbox, .editoraForm fieldset radio').not('[disabled]').not('[type="file"]').each(function() {
    $(this).on('change', function() {
      var value = $(this).val();
      var id = $(this).attr('id');

      $('[data-rel="' + id + '"]').val(value);
    });
  });

  $('input[data-lengthwarning]').each(function() {
    $(this).maxlength({
      placement: 'top',
      alwaysShow: true,
      allowOverMax: true,
      validate: false,
      customMaxAttribute: $(this).data('lengthwarning')
    });
  });

  //select2 amb ordenació i drag&drop
  var selectEl = $('.chzn-select-custom-order').select2();
  selectEl.next().find('ul').sortable({
      containment: 'parent', stop: function (event, ui) {
          element = ui.item.parent().parent().parent().parent().parent().find('select')[0];
          idElement = $(element).attr('id');
          var selectID = $('#'+idElement);
          ui.item.parent().children('[title]').each(function () {
              var title = $(this).attr('title');
              $('option:contains(\'' + title + '\')', selectID).filter(function(){
                  if ($(this).text() === title) {
                      var original = $(this);
                      original.detach();
                      $(selectID).append(original);
                  }
              });
          });
          selectEl.change();
      }
  });
  $(".chzn-select-custom-order").each(function(){
      $this = $(this);
      $this.on('select2:select', function(e){
      var elm = e.params.data.element;
      $elm = $(elm);
      $t = $(this);
      $t.append($elm);
      $t.trigger('change.select2');
      });
  });

  //Copiar la url d'una fitxa de dinàmica al porta-retalls
  $('body').on('click', '#copyURL', function(event){
      event.preventDefault();
      var text = $(this).data('url');
      navigator.clipboard.writeText(text).then(function() {
          var noutitol = $('#copyURL').data('copied-title');
          var titoloriginal = $('#copyURL').data('original-title');
          $('#copyURL').prop('title',  noutitol).tooltip('show');
          setTimeout(function() {
              $('#copyURL').prop('title', titoloriginal);
              $('#copyURL').tooltip('destroy');
          }, 800);
      }, function(err) {
      });
  });

});
